export default __webpack_public_path__ + "static/media/theme-7-hotel-bg.73cca077.png";